import { Component, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceSettingsSpecialistRecordStore } from './service-settings-specialist-record.store';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { FormBuilder } from '@angular/forms';
import { ConfirmBuilder } from '../../../../../shared/service/confirm.builder';
import { activeColumn, descriptionColumn, nameColumn } from '../../../../../shared/components/kit/table/table.fields';
import {
    ServiceSpecialistRecordWorkTypeModalComponent,
} from '../../../../components/services/settings/service-specialist-record-work-type-modal/service-specialist-record-work-type-modal.component';
import {
    ServiceSpecialistRecordContactTypeModalComponent,
} from '../../../../components/services/settings/service-specialist-record-contact-type-modal/service-specialist-record-contact-type-modal.component';
import {
    ServiceSpecialistRecordWorkTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-specialist-record-work-type.object';
import {
    ServiceSpecialistRecordContactTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-specialist-record-contact-type.object';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { contentGlobalSuccess } from '../../../../content.error';
import {
    SERVICE_SETTINGS_SPECIALIST_RECORD_TYPE_KEY,
} from '@libs/types/src/services/types/common-service-settings.type';
import { isAllowed } from '../../../../../shared/shared.global-service';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { CardTableComponent } from '../../../../../shared/components/kit/table/card-table.component';

@Component({
    selector: 'app-service-settings-specialist-record',
    templateUrl: 'service-settings-specialist-record.component.html',
    styleUrl: 'service-settings-specialist-record.component.scss',
    providers: [ServiceSettingsSpecialistRecordStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ServiceSettingsCommonComponent,
        CardTableComponent,
        ServiceSpecialistRecordWorkTypeModalComponent,
        ServiceSpecialistRecordContactTypeModalComponent,
    ],
})
export class ServiceSettingsSpecialistRecordComponent extends SubscriptionComponent {

    protected readonly store = inject(ServiceSettingsSpecialistRecordStore);
    private readonly fb = inject(FormBuilder);
    private readonly confirm = inject(ConfirmBuilder);

    @ViewChild(ServiceSpecialistRecordWorkTypeModalComponent) workTypeModal!: ServiceSpecialistRecordWorkTypeModalComponent;
    @ViewChild(ServiceSpecialistRecordContactTypeModalComponent) contactTypeModal!: ServiceSpecialistRecordContactTypeModalComponent;

    @ViewChild('specialistRecordWorkTypeTable') specialistRecordWorkTypeTable!: TableComponent;
    @ViewChild('specialistRecordContactTypeTable') specialistRecordContactTypeTable!: TableComponent;

    protected form = this.fb.group({});

    protected workTypeColumns = [
        activeColumn,
        nameColumn,
        descriptionColumn,
    ];

    protected contactTypeColumns = [
        activeColumn,
        nameColumn,
        descriptionColumn,
    ];

    constructor() {
        super();
        this.store.onSuccess(
            () => this.specialistRecordWorkTypeTable?.reload(),
            'createServiceSpecialistRecordWorkType',
            'updateServiceSpecialistRecordWorkType',
            'deleteServiceSpecialistRecordWorkType',
        );
        this.store.onSuccess(
            () => this.specialistRecordContactTypeTable?.reload(),
            'createServiceSpecialistRecordContactType',
            'updateServiceSpecialistRecordContactType',
            'deleteServiceSpecialistRecordContactType',
        );
    }

    protected createWorkType(): void {
        this.workTypeModal?.show();
    }

    protected updateWorkType(item: ServiceSpecialistRecordWorkTypeObject): void {
        this.workTypeModal?.show(true, item);
    }

    protected deleteWorkType(item: any): void {
        this.confirm.confirm(
            'common.delete',
            item.item.name,
            () =>
                this.store.api.deleteServiceSpecialistRecordWorkType({ id: item.item.id })
                    .then(() => contentGlobalSuccess.next('common.deleted')),
            null,
            'pi-trash',
            item.event.target,
        );
    }

    protected createContactType(): void {
        this.contactTypeModal?.show();
    }

    protected updateContactType(item: ServiceSpecialistRecordContactTypeObject): void {
        this.contactTypeModal?.show(true, item);
    }

    protected deleteContactType(item: any): void {
        this.confirm.confirm(
            'common.delete',
            item.item.name,
            () =>
                this.store.api.deleteServiceSpecialistRecordContactType({ id: item.item.id })
                    .then(() => contentGlobalSuccess.next('common.deleted')),
            null,
            'pi-trash',
            item.event.target,
        );
    }

    protected readonly SERVICE_SETTINGS_SPECIALIST_RECORD_TYPE_KEY = SERVICE_SETTINGS_SPECIALIST_RECORD_TYPE_KEY;
    protected readonly isAllowed = isAllowed;
}
